import { createStore } from 'vuex';
import SsoModule from './modules/sso';
import UserModule from './modules/user';
import PermissionModule from './modules/permission';
import TagsViewModule from './modules/tagsView';
import MenuModule from './modules/menus';
import AppModule from './modules/app';
import SettingsModule from './modules/settings';
import MainModule from './modules/main';
import CostShareModule from './modules/costShare';
import OdataSchema from './modules/common/odataSchema';
import ContractPlan from './modules/contractPlan';
import CostPlan from './modules/costPlan';
import expenseReview from './modules/expenseReview';
import { STORE_ROOT_NAME } from './modules/common/store-type';
// Vuex Module 集合，所有 Module 均在此处整合
const modules = {
  sso: SsoModule,
  user: UserModule,
  permission: PermissionModule,
  tagsView: TagsViewModule,
  menu: MenuModule,
  app: AppModule,
  main: MainModule,
  setting: SettingsModule,
  costShare: CostShareModule,
  contractPlan: ContractPlan,
  expenseReview,
  [STORE_ROOT_NAME]: {
    namespaced: true,
    modules: {
      [OdataSchema.name]: OdataSchema
    }
  },
  costPlan: CostPlan
};
const store = createStore({
  modules
});
export default store;